import { render, staticRenderFns } from "./TokenDropi.vue?vue&type=template&id=58754fb2&scoped=true&"
import script from "./tokenDropi.ts?vue&type=script&lang=ts&"
export * from "./tokenDropi.ts?vue&type=script&lang=ts&"
import style0 from "./TokenDropi.vue?vue&type=style&index=0&id=58754fb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58754fb2",
  null
  
)

export default component.exports